// Главная — чистые функции подписей (без React), чтобы проверять их тестами.
import type { TeamCard } from '../api/homeTypes';

type Rank = Pick<NonNullable<TeamCard['rank']>, 'position' | 'of' | 'league'>;

/** Подпись рейтинга команды: «#pos/of», имя лиги через « · » — только если оно есть (поле необязательно). */
export function rankCaption(rank: Rank): string {
  const league = rank.league?.name;
  return [`#${rank.position}/${rank.of}`, league].filter(Boolean).join(' · ');
}
